<main class="demands-page">
  <nav class="breadcrumb" aria-label="Breadcrumb">
    <a routerLink="/dashboard">Home</a>
    <img src="assets/demands/chevron-right.svg" alt="" />
    <span aria-current="page">{{ pageTitle }}</span>
  </nav>

  <section class="page-heading" aria-labelledby="page-title">
    <h1 id="page-title" class="page-title">{{ pageTitle }}</h1>
    <p>Track and manage your decommissioning and archival requests.</p>
  </section>

  <app-demands-table [pageTitle]="pageTitle" />
</main>
